import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    city: string,
    salaryRequest: number | null,
    workTime:number|null,
    becomingAwareThrough: string,
    becomingAwareThroughOther: string,
    periodOfCancellation: string,
    additionalNotes: string,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    city: string = "";
    salaryRequest: number | null = null;
    workTime: number | null = null;
    becomingAwareThrough: string="";
    becomingAwareThroughOther: string="";
    periodOfCancellation: string = "";
    additionalNotes: string = "";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "city", value: this.city },
            { name: "salaryRequest", value: this.salaryRequest?.toString() ?? "" },
            { name: "workTime", value: this.workTime?.toString() ?? "" },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "becomingAwareThroughOther", value: this.becomingAwareThroughOther },
            { name: "periodOfCancellation", value: this.periodOfCancellation },
            { name: "additionalNotes", value: this.additionalNotes },
        );

        return application;
    }
}
